import UserGiveawayForm from "components/cms/User/UserGiveawayForm"
import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "components/ui/breadcrumb/DefBreadcrumb"
import Typography from "components/ui/typography"
import { getCMSSegments } from "utils/helper"

const UserGiveaway = () => {
    const segments = getCMSSegments()

    return (
        <EmployeeDashboardWrapper>
            <DefBreadcrumb
                segments={segments}
                prefix="cms"
            />
            <div className="inline-flex items-center">
                <Typography
                    variant="subheading4"
                    as="h1"
                    className="text-primary mt-4 mb-4"
                >
                    Form Giveaway
                </Typography>
            </div>
            <UserGiveawayForm />
        </EmployeeDashboardWrapper>
    )
}

export default UserGiveaway
